var CONFUSEDCMS = CONFUSEDCMS || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

    CONFUSEDCMS.setupProviderList = function () {
        var $providersVisible;

        enquire.register(CSSCONSTANTS.nonMobileMinWidthMQ, {

            match: function () {
                $providersVisible = $('.' + CSSCONSTANTS.visibleProvidersClass);
                CONFUSEDCMS.createImages($providersVisible);
            },
            unmatch: function () {
                $providersVisible = $('.' + CSSCONSTANTS.visibleProvidersClass);
                CONFUSEDCMS.removeImages($providersVisible);
            }
        }, true);

        
        CONFUSEDCMS.createMoreProvidersButton();
        CONFUSEDCMS.setupProviderFilters();
       
    };

    CONFUSEDCMS.setupProviderFilters = function () {
        
        var $providers = $('.' + CSSCONSTANTS.providersClass),
            $providerFilters = $('.' + CSSCONSTANTS.providerFilterClass),
            $providerFilterShowAll = $('.' + CSSCONSTANTS.providerFilterShowAllClass),
            providerFilterActiveClass = CSSCONSTANTS.backgroundBlueClass,
            providerFilterInactiveClass = CSSCONSTANTS.backgroundPastel2Class;

        $.each($providerFilters, function () {
            var $this = $(this),
                lettersToFilter = $this.text();

            $this.on('click',function (e) {
                e.preventDefault();
                CONFUSEDCMS.filterProviders($providers, lettersToFilter);
                $providerFilterShowAll.add($providerFilters).removeClass(providerFilterActiveClass).addClass(providerFilterInactiveClass);
                $this.removeClass(providerFilterInactiveClass).addClass(providerFilterActiveClass);
                CONFUSEDCMS.removeMoreProvidersButton();
            });
        });

        $providerFilterShowAll.on('click',function (e) {
            e.preventDefault();
            CONFUSEDCMS.showAllProviders($providers);
            $providerFilterShowAll.add($providerFilters).removeClass(providerFilterActiveClass).addClass(providerFilterInactiveClass);
            $providerFilterShowAll.removeClass(providerFilterInactiveClass).addClass(providerFilterActiveClass);
            CONFUSEDCMS.removeMoreProvidersButton();
        });
    };
    
    CONFUSEDCMS.filterProviders = function ($providers, lettersToFilter) {

        $providers.removeClass(CSSCONSTANTS.visibleProvidersClass);
        $providers.addClass(CSSCONSTANTS.hiddenProvidersClass);
        
        $.each($providers, function () {
            var $this = $(this),
                thisProviderHref = $this.find('a').attr('href'),
                $thisProviderImage = $this.find('img'),
                thisProviderName,
                thisProviderFirstLetter;
           
            var thisProviderHrefSegment = thisProviderHref.lastIndexOf('/');
            thisProviderFirstLetter = thisProviderHref.charAt(thisProviderHrefSegment + 1).toUpperCase();

            if (lettersToFilter.indexOf(thisProviderFirstLetter) !== -1) {
                $this.removeClass(CSSCONSTANTS.hiddenProvidersClass);
                $this.addClass(CSSCONSTANTS.visibleProvidersClass);

                if (($thisProviderImage.length < 1) && (!matchMedia('(max-width: ' + CSSCONSTANTS.mobileMaxWidth + ')').matches)) {
                    CONFUSEDCMS.createImages($this);
                }
            }
           
        });
    };

    CONFUSEDCMS.createImages = function ($providersToShowImages) {

        $.each($providersToShowImages, function () {
            var $provider = $(this).find('a'),
                $providerImage,
                thisImageSrc = $provider.attr('data-img');
             
            $providerImage = $('<img />', {
                src: thisImageSrc,
                alt : $provider.text()
            });
            $provider.text('');
            $providerImage.appendTo($provider);
        });    
    };

    CONFUSEDCMS.removeImages = function ($providersToRemoveImages) { /* for removing images from visible providers when switching to mobile view */
        $.each($providersToRemoveImages, function () {
            var $this = $(this),
                $providerLink = $this.find('a'),
                $providerImg = $providerLink.find('img'),
                providerName = $providerImg.attr('alt');
            console.log(providerName);
            $providerLink.text(providerName);
            $providerImg.remove();
        });
    };

    CONFUSEDCMS.createMoreProvidersButton = function () {
        var $providerList = $('.' + CSSCONSTANTS.providerListClass),
            $hiddenProviders = $('.' + CSSCONSTANTS.hiddenProvidersClass),
            $moreLink,
            moreLinkText = 'Show more';

        if ($hiddenProviders.length >= 1) {

            $moreLink = $('<a />', {
                'class': CSSCONSTANTS.providerListMoreLinkClass,
                href: '#',
                text: moreLinkText
            });

            $moreLink.on('click', function (e) {
                e.preventDefault();
                CONFUSEDCMS.showMoreProviders();
            });
            
            $moreLink.insertAfter($providerList);
        }
    };

    CONFUSEDCMS.removeMoreProvidersButton = function () {
        var $moreLink = $('.' + CSSCONSTANTS.providerListMoreLinkClass);
        $moreLink.remove();
    };

    CONFUSEDCMS.showAllProviders = function ($providers) {
        $providers.removeClass(CSSCONSTANTS.hiddenProvidersClass);
        $providers.addClass(CSSCONSTANTS.visibleProvidersClass);
        $.each($providers, function () {
            var $this = $(this),
                $thisProviderImage = $this.find('img');

            if (($thisProviderImage.length < 1) && (!matchMedia('(max-width: ' + CSSCONSTANTS.mobileMaxWidth + ')').matches)) {
                CONFUSEDCMS.createImages($this);
            }
        });
    };

    CONFUSEDCMS.showMoreProviders = function () {
        var $hiddenProviders = $('.' + CSSCONSTANTS.hiddenProvidersClass),
            $moreLink = $('.' + CSSCONSTANTS.providerListMoreLinkClass);
       
        $.each($hiddenProviders, function () {
            var $this = $(this);

            $this.removeClass(CSSCONSTANTS.hiddenProvidersClass).addClass(CSSCONSTANTS.visibleProvidersClass);

        });

        if (!matchMedia('(max-width: ' + CSSCONSTANTS.mobileMaxWidth + ')').matches) {
            CONFUSEDCMS.createImages($hiddenProviders);
        }
        
        $moreLink.remove();

    };

})(window.jQuery);


